import React from "react";
import { Provider } from "react-redux";
import store from "@redux/store";
import InvestmentJourney from "../pages/InvestmentJourney";
var PMSApp = function (_a) {
    var subCategoryId = _a.subCategoryId;
    return (React.createElement(Provider, { store: store },
        React.createElement(InvestmentJourney, { subCategoryId: Number(subCategoryId) })));
};
export default PMSApp;
